export default __webpack_public_path__ + "alarmStatus-disarmed.677974e8.png";